<template>
  <div class="commonQuestion">
    <div class="common_content">
      <el-card class="box-card">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item
            v-for="(item,index) in data"
            :name="index"
            :key="index"
            :title="item.news_subject"
          >
            <div v-html="item.news_content"></div>
            <img :src="getImgUrl(item.thumbnail)" v-if="item.thumbnail"/>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetQuestionsList } from "@/api/admin/common.js";
export default {
  data() {
    return {
      data: [],
      activeName: "1",
      imgPath:window.apiObj.apiUrl
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //图片路径拼接
    getImgUrl(file_path){
        var url = this.imgPath+file_path;
        return url;
    },
    getList() {
      GetQuestionsList({ question: 1}).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
        }
      });
    }
  }
};
</script>

<style lang="less">
.commonQuestion{
  img{
    width:100%
  }
}
</style>